<template>
  <div class="animated fadeIn fadeOut">
    <b-row>
      <b-col lg="12" xl="12">

        <b-card>
          <b-row>
            <b-col md="1"></b-col>
            <b-col md="2">
              <label for="ph_is_publish" v-b-tooltip.hover title="rule can be a publish or prepare deploy">Publish</label>
              <b-form-group>
                <c-switch color="info" label size="sm" v-model="model.is_publish"/>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <label for="version" v-b-tooltip.hover title="New Version is more highier then latest version">CRS Rule(+ Vender Rule) Version</label> <small v-if="last_version && !model.id">Latest : {{last_version}}</small>
              <br>
              <b-input :state="model.version != null && model.version != '' ? true : false" class="" v-model="model.version"></b-input>
            </b-col>
            <b-col md="1"></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="1"></b-col>
            <b-col md="2">
              <label for="ph_created_at" v-b-tooltip.hover title="Status about rule, enable or disable">Status</label>
              <b-form-group>
                <c-switch color="info" label size="sm" v-model="model.is_alive"/>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <label for="agent_version" v-b-tooltip.hover title="New Version is more highier then latest version">required Minimum Agent Version</label> <small v-if="last_version && !model.id">Latest : {{last_version}}</small>
              <br>
              <b-input :state="model.agent_version != null && model.agent_version != '' ? true : false" class="" v-model="model.agent_version"></b-input>
            </b-col>
            <b-col md="1"></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_created_at" v-b-tooltip.hover title="Registed_at">Registed_at</label><br>
                <label for="ph_created_at" v-if="model && model.created_at">{{model.created_at | datetime}}</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_registed_at" v-b-tooltip.hover title="Last Modefiy">Last Modify</label><br>
                <label for="ph_registed_at" v-if="model && model.updated_at">{{model.updated_at | datetime}}</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <label for="Manage" v-b-tooltip.hover title="Manage">Search</label><br>
              Press Control + F
            </b-col>
            <b-col md="3">
              <label for="Manage" v-b-tooltip.hover title="Manage">Manage</label><br>
              <b-button size="sm" variant="danger" @click="confirm_remove = true" :disabled="!(model && model.id)"> Delete </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-button size="sm" class="w-100" variant="primary" @click="list"> List </b-button>
          <hr>
          <b-button size="sm" class="w-100" variant="warning" @click="() => { model && model.id ? confirm_update = true : save() }"> Save </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="6">
        <b-card>
          <h4>CRS RULE</h4>
          <hr>
          <codemirror @change="change" ref="cm_rule" v-model="model.crs_rule" :options="options_rule"/>
          <!-- <prism-editor @change="change" :code="model.crs_rule" language="html"></prism-editor> -->
          <hr>

        </b-card>
      </b-col>
      <b-col lg="12" xl="6">
        <b-card>
          <h4>
            CRS RULE JSON :
            <b-badge variant="success" v-if="json_validation">Good</b-badge>
            <b-badge v-else variant="secondary">Bad Json format</b-badge>
          </h4>
          <hr>
          <!-- <prismEditor @change="change_json" :code="model.crs_json" language="json" /> -->
          <!-- <prism-editor class="my-editor" v-model="code" :highlight="highlighter" line-numbers></prism-editor> -->
          <!-- <editor-content :editor="editor" /> -->
          <codemirror @change="change_json" ref="cm_json" v-model="model.crs_json" :options="options_json"/>
          <hr>
        </b-card>
      </b-col>
    </b-row>
    <!-- start modal area -->
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm_remove" @ok="remove" ok-variant="danger">
      Are you sure you want to delete the data?
    </b-modal>
    <b-modal title="Content Update"  class="modal-primary" v-model="confirm_update" @ok="save" ok-variant="primary">
      Are you sure you want to update the data?
    </b-modal>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { Api , auth} from '@/service';
import codes from '@/codes';
// import PrismEditor from 'vue-prism-editor'
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';

import { codemirror } from 'vue-codemirror'

import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/base16-dark.css'

// language
import 'codemirror/mode/vue/vue.js'

import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

export default {
  components: { cSwitch, VueEditor, codemirror },
  data : () => {
    return {
      last_version : '',
      auth,
      lock : false,
      model : {},
      parnter_name : '',
      codes,
      reload : true,
      init : '',
      confirm_remove : false,
      confirm_update : false,
      json_validation : false,
      // codemirror options
      options_rule: {
        tabSize: 4,
        // mode: 'text',
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
        mode: 'text/javascript',
        lineWrapping: true,
      },
      options_json: {
        tabSize: 4,
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
        mode: 'text/javascript',
        lineWrapping: true,
      }
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.html); // languages.<insert language> to return html with markup
    },
    refresh(id) {
      this.$router.push({ name: 'webcastle.policy', params : { id : id ? id : this.model.id } });
    },
    change(content) {
      this.model = Object.assign({}, this.model, { crs_rule : content })
    },
    change_json(content) {
      this.model = Object.assign({}, this.model, { crs_json : content })
      this.json_validation = true
      try { JSON.parse(content.toString())  } catch (e) { console.log("is not json format"); this.json_validation = false }

    },
    list() { this.$router.push({ name: 'webcastle_policy'}); this.$emit('refresh'); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.latest(); this.model.is_alive = true; return; }
      try {
        let rs = await Api.Manager_Call('webcastle.policy', 'detail', { id : id });
        if(rs.error) { return this.$toastr.e("load failed") }
        this.model = Object.assign({}, this.model, rs.body)
        this.json_validation = true
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async remove() {
      try {
        let rs = await Api.Manager_Call('webcastle.policy', 'remove', { id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed', this.$route.name);
          this.list();
        } else {
          this.$toastr.e('Remove', "failed");
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async save() {
      try {
        if(!(this.model.version || '').trim()) { return this.$toastr.e("version", "require") }
        if(!(this.model.crs_rule || '').trim()) { return this.$toastr.e("Rule", "require") }
        if(!(this.model.crs_json || '').trim()) { return this.$toastr.e("Rule JSON", "require") }
        if(!this.json_validation) { return this.$toastr.e("Rule JSON", "require json format") }

        let rs = await Api.Manager_Call('webcastle.policy', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.model = Object.assign({}, this.model, rs.body)
            rs.body
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.lock = true;
    },
    async latest() {
      try {
        let rs = await Api.Manager_Call('webcastle.policy', 'latest', { body : 'body' });
        if(!rs.error) {
          this.last_version = rs.body
        } else {
          this.$toastr.e('last version load failed');
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('webcastle.policy.detail.vue', 'created'); },
  destroyed: function() { console.log('webcastle.policy.detail.vue', 'destroyed'); },
  mounted: function() { console.log('webcastle.policy.detail.vue', 'mounted'); this.get(this.$route.params); },
}
</script>
